}

// isNode
if(typeof process !== 'undefined' && process.execPath)
	module.exports = SFDatabase;